/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { TextInput, Checkbox } from "react-materialize";
import API from "../../utils/API";
import Html from "../../utils/Html";

import RelateFilter from "./top.content.relate.filter";
import FilterOrganization from "./top.content.filter.organization";
import FilterJobClass from "./top.content.filter.jobclass";

export default function TopContent({
  defaultFilters,
  key_form,
  showFullnameAndPosition,
  handleEvents,
}) {
  let filters = defaultFilters;
  filters["key_form"] = key_form;
  filters["organization"] =
    "organization" in defaultFilters ? defaultFilters["organization"] : [];

  const [relateFilters, setRelateFilters] = useState({
    data: filters["organization"],
    key_form: key_form,
  });
  const [filterData, setFilterData] = useState({
    data: "",
    err: 0,
    err_msg: "",
    status: "",
  });

  useEffect(() => {
    const mainFunc = async () =>
      await API.post("org/filter", {
        params: {
          filters: filters,
        },
      });

    mainFunc()
      .then((res) => {
        const decrypt = res?.data;
        if (decrypt?.status === "success") {
          setFilterData(decrypt);
        } else {
          setFilterData({
            err: 1,
            err_msg: `Failes : ` + (decrypt?.err_msg ?? ""),
          });
        }
      })
      .catch((err) => {
        setFilterData({ err: 1, err_msg: `Failes : ${err}` });
      });
  }, [filters]);

  if (filterData.err == 1) {
    return <div>Fetch request error: {filterData.err_msg}</div>;
  } else if (filterData.data == "") {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  }

  return (
    <div id="top-content">
      <form
        key={"form-filter-request" + filters.key_form}
        id="form-filter-request"
        method="post"
      >
        <div className="filter-inputs row">
          <FilterOrganization
            data={filterData["data"]["organizations"]}
            filters={{
              data: filters["organization"],
              key_form: filters["key_form"],
            }}
          />
          <RelateFilter
            filters={relateFilters}
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <FilterJobClass
            data={filterData["data"]["jobClasses"] ?? []}
            key_form={filters["key_form"]}
          />
        </div>
        <div className="row" style={{ marginTop: "15px" }}>
          <div
            className="col s6"
            style={{ marginLeft: "-10px", paddingLeft: "0px" }}
          >
            <Feature.FilterName />
          </div>

          <div
            className="col s6"
            style={{ lineHeight: "55px", paddingLeft: "20px" }}
          >
            <Feature.SelectShowFullnameAndPosition
              showInfo={showFullnameAndPosition}
              handleEvents={handleEvents.SelectShowFullNameAndPosition}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

const Feature = {};
Feature.FilterName = () => {
  return (
    <div key="filter-name" className="filter-input-field">
      <TextInput
        placeholder=""
        id="filter-inp-name"
        name="name"
        label="Name, Email and Position"
      />
    </div>
  );
};

Feature.SelectShowFullnameAndPosition = ({ showInfo, handleEvents }) => {
  return (
    <div id="show_fullname_and_position">
      <div id="checkbox-group">
        <Checkbox
          label="Show Full Name & Position"
          value="isShowFullnameAndPosition"
          checked={showInfo ?? false}
          onChange={handleEvents.OnChange}
          filledIn
        />
      </div>
    </div>
  );
};
